export default __webpack_public_path__ + "static/media/Versions - vs Official vs Films_02.79ef091f.jpg";